import React from 'react'
import { Box, Flex, Text, useTheme } from '@homebotapp/hb-react-component-catalog'
import useViewport from '../../../hooks/useViewport'
import { interpolateColor } from './marketTempHelpers'

interface TemperatureIndicatorProps {
  marketTemp: number
  isSmall?: boolean
}

const MARKET_TEMP_LABEL_OVERLAP_THRESHOLDS = {
  MIN: 4,
  MAX: 96
}

const MARKET_TEMP_LABEL_OVERLAP_THRESHOLDS_SMALL = {
  MIN: 8,
  MAX: 92
}

export const TemperatureIndicator: React.FC<TemperatureIndicatorProps> = ({ marketTemp, isSmall }) => {
  const { theme } = useTheme()
  const viewport = useViewport()

  const thresholds =
    isSmall || viewport.isSmall ? MARKET_TEMP_LABEL_OVERLAP_THRESHOLDS_SMALL : MARKET_TEMP_LABEL_OVERLAP_THRESHOLDS
  const indicatorColor = interpolateColor(marketTemp, theme)

  return (
    <Box
      position='relative'
      height='24px'
      borderRadius='12px'
      mt={6}
      sx={{
        background: `linear-gradient(90deg, ${theme.isLightThemeType ? '#105998' : '#5AA3EE'} 0%, ${
          theme.isLightThemeType ? '#5D00C5' : '#BDA8FF'
        } 50%, ${theme.isLightThemeType ? '#AD0054' : '#F7749E'} 100%)`
      }}
    >
      <Flex position='absolute' width='100%' height='100%' justify='space-between' align='center' paddingX={3}>
        <Box>
          {marketTemp >= thresholds.MIN && (
            <Text size='s' color='neutral.100' mb={0} fontWeight='600'>
              0
            </Text>
          )}
        </Box>
        <Box>
          {marketTemp <= thresholds.MAX && (
            <Text size='s' color='neutral.100' mb={0} fontWeight='600'>
              100
            </Text>
          )}
        </Box>
      </Flex>
      <Box
        position='absolute'
        left={
          marketTemp < thresholds.MIN
            ? `${thresholds.MIN}%`
            : marketTemp > thresholds.MAX
            ? `${thresholds.MAX}%`
            : `${marketTemp}%`
        }
        top='50%'
        transform='translate(-50%, -50%)'
        width='56px'
        height='56px'
        borderRadius='50%'
        // @ts-ignore
        backgroundColor={theme.isLightThemeType ? 'white !important' : 'neutral.50'}
        color='neutral.900'
        border='2.5px solid'
        borderColor={indicatorColor}
        display='flex'
        alignItems='center'
        justifyContent='center'
        sx={{
          fontSize: '30px'
        }}
      >
        {marketTemp}
      </Box>
    </Box>
  )
}
